import * as utils from 'app/utils';
import * as _ from 'lodash'
import * as moment from 'moment'
import * as React from 'react'

interface IRetirementAgeSelectorProps {
  selectedValue: moment.Duration
  fontSize?: string
  min: number
  max: number
  width?: string
  anyPlaceholder?: any,
  placeholder?: string
  required?: boolean
  onChange: (age: moment.Duration) => void
}

interface IRetirementAgeSelectorState {
  age: moment.Duration
}

class RetirementAgeSelector extends React.Component<IRetirementAgeSelectorProps, IRetirementAgeSelectorState> {
  state = {
    age: null
  }

  componentDidMount() {
    const age = this.props.selectedValue
    this.setState({ age })
  }

  selectAge(ageYears: number) {
    const age = moment.duration(ageYears, 'years')
    this.setState({ age })
    if (this.props.onChange) { this.props.onChange(age) }
  }

  render() {
    //if (!this.state.age) { return null; }
    const styles: any = { }
    if (this.props.width) { styles.width = this.props.width }
    const paintPlaceholder = !!this.props.placeholder || !!this.props.anyPlaceholder
    const errorClass = this.props.required && !utils.isGoodDuration(this.state.age) ? ' has-error' : ''
    const classes = 'material-ageSelector-group hasValue' + errorClass
    return (
      <div className={classes} style={styles}>
        {paintPlaceholder && <label className="material-input-placeholder">{this.props.placeholder}{this.props.anyPlaceholder}</label>}
        <div>
          {this.renderAge()}
        </div>
      </div>)
  }

  renderAge() {
    const age = this.state.age
    const ages = _.range(this.props.min, this.props.max + 1)
    return _.map(ages, (a) => {
      const bingo = age ? a === age.years() : false
      const styles: any = { }
      if (this.props.fontSize) { styles.fontSize = this.props.fontSize }
      let cls = bingo ? 'ageSelectorCurrent' : ''
      cls += ' material-ageSelector-ages'
      return <div style={styles} className={cls} key={a}>&nbsp;<a href="javascript:void(0)" onClick={() => this.selectAge(a)}>{a}</a>&nbsp;</div>
    })
  }
}

export {
  RetirementAgeSelector
}



// WEBPACK FOOTER //
// ./src/app/components/form/RetirementAgeSelector/index.tsx